// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".M-Qp1A32gEKO-QYG21zkmQ\\=\\={-ms-overflow-style:none;scrollbar-width:none}.M-Qp1A32gEKO-QYG21zkmQ\\=\\=::-webkit-scrollbar{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hideScrollbar": "M-Qp1A32gEKO-QYG21zkmQ=="
};
module.exports = ___CSS_LOADER_EXPORT___;
